<template>
  <div class="video-box">
    <div class="atta-line" v-if="isBorder && (file || url)"></div>
    <div class="media-list" v-if="file || url">
      <div class="video">
        <img
          src="@/assets/bg_16x9@3x.png"
          alt="default"
          class="video-def-img"
          v-if="state === 0 || state === 2 || !isMp4"
        />
        <img :src="poster" alt="poster" v-if="state === 1 && isMp4" />
        <img
          src="@/assets/clock/clockin_icon_cover_play.png"
          alt=""
          class="play-btn"
          v-if="state === 1"
        />
        <div class="time-text" v-if="state === 1">{{duration}}</div>
        <div class="show-model" v-if="state === 0 || state === 2">
          <van-circle
            v-model="currRate"
            :rate="videoRate"
            layer-color="rgba(255, 255, 255, 0.4)"
            :speed="100"
            color="#fff"
            size="36px"
            :text="videoText"
            v-if="state === 0"
          ></van-circle>
          <template v-if="state === 2">上传失败</template>
        </div>
        <!-- 视频重新上传按钮 -->
        <img
          src="@/assets/clockin_icon_sequel.png"
          alt="again"
          class="video-error"
          @click="againUploadVideo"
          v-if="state === 2"
        />

        <div class="no-long-press"></div>
      </div>
      <img
        src="@/assets/clock/clockin_icon_delete.png"
        alt=""
        class="img-del-com"
        @touchstart="delVideo"
        v-if="state === 1"
      />
    </div>

    <!-- 上传视频弹窗 -->
    <ActionSheet
      v-model="show"
      :close-on-click-overlay="false"
      @click-overlay="closeVideoDia"
      safe-area-inset-bottom
    >
      <div class="content-img">
        <div class="upload-text">
          <Uploader
            accept="video/*"
            capture="camera"
            :max-size="200 * 1024 * 1024"
            :preview-image="false"
            :before-read="beforeReadVideo"
            :after-read="afterReadVideo"
          >
            录像
          </Uploader>
        </div>
        <div class="upload-text">
          <Uploader
            accept="video/*"
            :max-count="1"
            :max-size="200 * 1024 * 1024"
            :preview-image="false"
            :before-read="beforeReadVideo"
            :after-read="afterReadVideo"
          >
            从手机相册选择
          </Uploader>
        </div>
        <div class="cancel-box">
          <button class="cancel-btn" @click="closeVideoDia">取消</button>
        </div>
      </div>
    </ActionSheet>
  </div>
</template>

<script>
import { uploadSlice, getAgoUploadLen, submitCDN } from '@/api/clockin';
import cryptoJs from 'crypto-js';
import { isIos } from '@/common/js/utils';

import {
  Circle, Toast, ActionSheet, Uploader
} from 'vant';

export default {
  props: {
    src: {
      type: String,
      default: '',
    },
    show: {
      type: Boolean,
      default: false,
    },
    isBorder: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'van-circle': Circle,
    ActionSheet,
    Uploader,
  },
  data() {
    return {
      file: null,
      url: '',
      state: 0,
      poster: '',
      isMp4: false,
      currRate: 0, // 视频当前进度
      videoRate: 0, // 视频上传进度
      videoText: '0%',
      duration: '',
      video: null
    };
  },
  watch: {
    url(val) {
      if (val) {
        if (val.indexOf('mp4') !== -1) {
          this.isMp4 = true;

          if (val.indexOf('?') > 0) {
            this.poster = `${val}&x-oss-process=video/snapshot,t_600,f_jpg,w_160,h_90,m_fast`;
          } else {
            this.poster = `${val}?x-oss-process=video/snapshot,t_600,f_jpg,w_160,h_90,m_fast`;
          }
        } else {
          this.isMp4 = false;
        }

        if (!this.src) {
          this.$emit('upload', { url: val, loading: false });
        }

        this.getVideoDuration(val);
      }
    },
    state(val) {
      if (val === 2) {
        this.$emit('upload', { url: '', loading: false });
      }
    },
    src: {
      handler(val) {
        if (val) {
          this.url = this.src;
          this.state = 1;
        }
      },
      immediate: true,
    },
  },
  methods: {
    /**
     * @description 上传 视频
     */
    async uploadVideo(file) {
      const hash = this.getFileHash(file);
      const start = await this.getUploadLen(hash);

      if (start) {
        if (start > file.size) {
          this.videoRate = 100;
        } else {
          this.videoRate = Math.floor((start / file.size) * 100);
        }

        this.videoText = `${this.videoRate}%`;
      }

      const piece = 1024 * 512;
      const chunks = this.fileSlice(file, start, piece);
      let allSuccess = true;

      for (let i = 0; i < chunks.length; i++) {
        const offset = i * piece + start;
        // eslint-disable-next-line no-await-in-loop
        const success = await this.uploadFileSlice(
          hash,
          offset,
          chunks[i].size,
          chunks[i]
        );

        const size = (i + 1) * piece + start;

        if (size > file.size) {
          this.videoRate = 100;
        } else {
          this.videoRate = Math.floor((size / file.size) * 100);
        }

        this.videoText = `${this.videoRate}%`;

        if (!success) {
          allSuccess = false;
          this.state = 2;
          break;
        }
      }

      if (allSuccess) {
        submitCDN(hash).then((res) => {
          this.state = 1;
          this.url = res.data.url;
        });
      }
    },
    /**
     * @description 计算文件的哈希值，用作唯一标识
     * @param {object} file 文件对象
     * @returns {string} 返回文件的唯一标识
     */
    getFileHash(file) {
      const blob = file.slice(0, 1024 * 1024 * 0.5);
      return cryptoJs.MD5(blob + file.name + file.size).toString();
    },
    /**
     * @description 将文件分块
     * @param {object} file 文件对象
     * @param {number} [start = 0] 从文件的哪里开始，默认0
     * @param {number} [piece = 1024 * 512] 每一块大小，默认512k
     * @returns {object[]} 返回一个文件分块数组
     */
    fileSlice(file, start = 0, piece = 1024 * 512) {
      const total = file.size;
      let end = start + piece;

      if (end > total) {
        end = total;
      }

      const chunks = [];
      while (end <= total) {
        const blob = file.slice(start, end);
        chunks.push(blob);

        if (end === total) {
          break;
        }

        start = end;
        end = start + piece;

        if (end > total) {
          end = total;
        }
      }

      return chunks;
    },
    /**
     * @description 上传文件切片
     * @param {string} hash 文件标识，md5字符串
     * @param {number} offset 偏移量
     * @param {number} length 切片长度
     * @param {object} blob 切片后的文件
     * @returns 上传成功返回true，失败false
     */
    async uploadFileSlice(hash, offset, length, blob) {
      const res = await uploadSlice({ hash, offset, length }, blob).catch(
        () => false
      );

      if (!res || !res.success) {
        return false;
      }

      return true;
    },
    /**
     * @description 获取该文件之前上传的进度
     * @param {string} hash 文件标识
     * @returns {number} 成功返回进度，失败返回0
     */
    async getUploadLen(hash) {
      const res = await getAgoUploadLen(hash).catch(() => false);

      if (!res || !res.success) {
        return 0;
      }

      return res.data.result;
    },
    beforeReadVideo(file) {
      if (file.size > 200 * 1024 * 1024) {
        Toast('视频大小超过200M');
        return false;
      }

      this.$emit('update:show', false);
      return true;
    },
    afterReadVideo(file) {
      const fileObj = file.file;

      this.state = 0;
      this.file = fileObj;

      this.$emit('upload', { url: '', loading: true });
      this.uploadVideo(fileObj);
    },
    closeVideoDia() {
      this.$emit('update:show', false);
    },
    delVideo() {
      this.file = null;
      this.url = '';
      this.state = 0;
      this.poster = '';
      this.currRate = 0;
      this.videoRate = 0;
      this.videoText = '0%';
      this.$emit('delete');
    },
    againUploadVideo() {
      if (this.file) {
        this.state = 0;
        this.uploadVideo(this.file);
      } else {
        Toast('重新上传失败');
      }
    },
    getVideoDuration(url) {
      if (localStorage.videos) {
        const videos = JSON.parse(localStorage.videos);
        const idx = videos.findIndex(item => item.url === url);

        if (idx !== -1) {
          this.duration = videos[idx].duration;
          return;
        }
      }

      try {
        const video = new Audio(url);
        video.preload = 'metadata';
        this.video = video;

        video.addEventListener('loadedmetadata', this.formatTime);

        if (isIos()) {
          // eslint-disable-next-line no-undef
          if ((typeof WeixinJSBridge) !== 'object' && (typeof WeixinJSBridge.invoke) !== 'function') {
            return;
          }

          // eslint-disable-next-line no-undef
          WeixinJSBridge.invoke('getNetworkType', {}, () => {
            video.muted = true;
            video.play();

            setTimeout(() => {
              video.pause();
            }, 1000);
          });
        }
      } catch (ex) {
        console.error(ex, '获取视频时长错误');
      }
    },
    formatTime() {
      let { duration } = this.video;
      duration = Math.floor(duration);

      if (duration < 60) {
        this.duration = `00:${duration > 9 ? duration : `0${duration}`}`;
      } else if (duration < 3600) {
        const minutes = Math.floor(duration / 60);
        const seconds = duration % 60;

        this.duration = `${minutes > 9 ? minutes : `0${minutes}`}:${seconds > 9 ? seconds : `0${seconds}`}`;
      } else {
        this.duration = '';
      }

      this.video.removeEventListener('loadedmetadata', this.formatTime);
      this.video = null;

      if (this.duration) {
        setTimeout(() => {
          this.saveDuration();
        }, 0);
      }
    },
    saveDuration() {
      if (!localStorage.videos) {
        localStorage.videos = JSON.stringify([{ url: this.url, duration: this.duration }]);
        return;
      }

      const videos = JSON.parse(localStorage.videos);

      if (videos.length > 555) {
        videos.splice(0, 444);
      }

      const idx = videos.findIndex(item => item.url === this.url);

      if (idx !== -1) {
        return;
      }

      videos.push({ url: this.url, duration: this.duration });
      localStorage.videos = JSON.stringify(videos);
    }
  },
};
</script>

<style lang="stylus" scoped>
videoSize =
  width: 160px;
  height: 90px;

.media-list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 0 20px 0;
  width: 100%;
}

.video {
  position: relative;
  height: 90px;
  background: #F1C5CF;

  .video-def-img {
    {videoSize};
  }

  .play-btn {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -18px;
    margin-left: -18px;
    width: 36px;
    height: 36px;
  }

  .time-text {
    position: absolute;
    bottom: 8px;
    right: 8px;
    height: 10px;
    line-height: 10px;
    font-size: 10px;
    color: #fff;
    text-shadow: 0px 0px 4px rgba(0, 0, 0, 0.4);
  }

  .no-long-press {
    opacity 0
    position absolute
    top 0
    left 0
    width 160px
    height 90px
  }
}

.show-model {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  {videoSize};
  background: rgba(0, 0, 0, 0.4);
  font-size: 15px;
  color: #fff;

  /deep/ .van-circle__text {
    padding: 0;
    font-size: 8px;
    color: #fff;
  }
}

.video-error {
  position: absolute;
  top: 50%;
  right: -26px;
  width: 18px;
  height: 18px;
  transform: translateY(-50%);
}

.img-del-com {
  width: 25px;
  height: 24px;
  border: none;
}

.content-img {
  padding: 0;
  margin: 0;
}

.upload-text {
  width: 100%;
  font-size: 16px;
  color: #191919;
  text-align: center;
  border-bottom: 0.5px solid #E7E7E7;
}

.cancel-box {
  padding: 20px 0;
  width: 100%;
  font-size: 16px;
  color: #999999;
  text-align: center;
  border-top: 8px solid #F6F7FA;
}

.cancel-btn {
  width: 100%;
  text-align: center;
  border: none;
  outline: none;
  background: rgba(0, 0, 0, 0);
}

.atta-line {
  width: 100%;
  height: 0.5px;
  background: #e7e7e7;
}

/deep/ .van-popup--bottom.van-popup--round {
  border-radius 12px 12px 0 0
}

/deep/ .van-uploader {
  width 100%
}

/deep/ .van-uploader__wrapper {
  display flex
  align-items center
  justify-content center
}

/deep/ .van-uploader__input-wrapper {
  width 100%
  padding: 20px 0;
}
</style>
